import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromAuthTasks from './iauthorized-task.actions';
import { switchMap, map, tap, catchError } from 'rxjs/operators';
import { TimeCardService } from '../time-card.service';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromShared from '../../shared';
@Injectable()
export class IAuthorizedTasksEffects {
    constructor(
        private actions$: Actions,
        @Inject(TimeCardService) private service: TimeCardService,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    getAuthorizedTasks$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromAuthTasks.getAuthorizedTasks),
            tap(a =>
                this.log.verbose({
                    type: 'IAuthorizedTasksEffects:getAuthorizedTasks$',
                    a
                })
            ),
            switchMap(a =>
                this.service
                    .getTasks(a.EmployeeListID, a.AuthType, a.AsOfDate)
                    .pipe(
                        map(at =>
                            fromAuthTasks.loadAuthorizedTasks({
                                authorizedTasks: at
                            })
                        ),
                        catchError(fromShared.Errors.handleServiceError)
                    )
            )
        )
    );
}
